module.exports = __webpack_public_path__ + "img/question.c46a35c7.png";